/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/8
 * Description: 文件描述
 */

import enLocale from 'element-ui/lib/locale/lang/en'
import enUs from '@/components/draggleForm/lang/en-US.js'
const en = {
    routeName: {
        scaleKeyword: 'scaleKeyword',
        StartTest: "StartTest",
        admQuery: "admQuery",
        prescribe: "prescribe",
        register: "register",
        test: "test",
        icon: 'icon',
        builtInIcon: 'builtInIcon',
        shuttleBox: 'shuttleBox',
        demoShuttle: 'demoShuttle',
        permissions: 'permissions',
        pageControl: 'pageControl',
        btnControl: 'btnControl',
        table: 'table',
        multiDataTable: 'multiDataTable',
        filterTable: 'filterTable',
        dragSort: 'dragSort',
        upload: 'upload',
        fileUpload: 'fileUpload',
        editor: 'editor',
        markdown: 'markdown',
        wangeditor: 'wangeditor',
        multiDirectory: 'multiDirectory',
        home: 'home',
        systemSettings: 'systemSettings',
        userManage: 'userManage',
        diagnosisManage: 'diagnosisManage',
        roleManage: 'roleManage',
        baseData: 'baseData',
        navMenu: 'navMenu',
        menuManage: 'menuManage',
        authManage: 'authManage',
        doctorListManage: "doctorListManage",
        introduceDetail: "introduceDetail",
        patientManage: "patientManage",
        hospitalManage: 'hospitalManage',
        hospitalSetting: 'hospitalSetting',
        departmentManage: 'departmentManage',
        dictManage: 'dictManage',
        dictsortManage: 'dictsortManage',
        measure: 'measure',
        DesignForm: "DesignForm",
        questionManage: "questionManage",
        scaleManage: "scaleManage",
        patientQuery: "patientQuery",
        packageManage: "packageManage",
        examManage: "examManage",
        examQuery: "examQuery",
        chineseMedicine: "chineseMedicine",
        physiqueQuery: "physiqueQuery",
        physiqueResultQuery: "physiqueResultQuery",
        Train: "Train",
        TrainReg: "TrainReg",
        TrainQuery: "TrainQuery"
    },
    rightMenu: {
        close: 'close',
        closeOther: 'closeOther',
        closeAll: 'closeAll'
    },
    table: {
        Status: "Status",
        action: 'action',
        stopuse: 'stopuse',
        use: 'use'
    },
    role: {
        superAdmin: 'superAdmin',
        admin: 'admin',
        ordinary: 'ordinary'
    },
    userDropdownMenu: {
        basicInfor: 'basicInfor',
        changePassword: 'changePassword',
        logout: 'logout'
    },
    ...enUs,
    ...enLocale //  合并element-ui内置翻译
}

export default en


// WEBPACK FOOTER //
// ./src/i18n/lang/en.js